import { MouseEventHandler, ReactNode } from "react";

export interface IGenericButtonProps {
    onClick?: MouseEventHandler<HTMLButtonElement>;
    title?: string;
    type?: "submit" | "reset" | "button";
    className?: string;
    disabled?: boolean;
}

export interface IButtonProps extends IGenericButtonProps {
    children?: ReactNode;
    style?: ButtonVariants;
}

export enum ButtonVariants {
    Default = 'btn-default',
    Primary = 'btn-primary',
    Danger = 'btn-danger',
    Success = 'btn-success',
    Warning = 'btn-warning',
}

export enum Icons {
    Add = 'glyphicon-plus',
    Delete = 'glyphicon-trash',
    Edit = 'glyphicon-edit',
    Home = 'glyphicon-home',
    Eye = 'glyphicon-eye-open',
    File = 'glyphicon-file',
    Folder = 'glyphicon-folder-close',
    ChevronDown = 'glyphicon-chevron-down',
    ChevronUp = 'glyphicon-chevron-up',
    ChevronLeft = 'glyphicon-chevron-left',
    ChevronRight = 'glyphicon-chevron-right',
    Download = 'glyphicon-download',
    Upload = 'glyphicon-arrow-up',
}

export interface IIconProps {
    icon: Icons;    
}

export const Icon = ({icon}: IIconProps) => {
    return (
        <span className={`glyphicon ${icon}`}/>
    )
}

export interface ITromanButtonProps extends IGenericButtonProps {
    text: string;
    variant?: ButtonVariants;
    icon?: Icons;
}

export const TromanButton = (props: ITromanButtonProps) => {
    return (
        <button type={props.type || 'button'} className={`btn ${props.variant || ButtonVariants.Default} ${props.className||''}`} onClick={props.onClick} title={props.title} disabled={props.disabled}>
            { props.icon && <Icon icon={props.icon}/> }
            <span style={{marginLeft: '3px'}}>{props.text}</span>
        </button>
    );
};

export const SlimButton = (props: IGenericButtonProps & IIconProps) => {
    return (
        <button type="button" className={`slimButton ${props.className||''}`} onClick={props.onClick} disabled={props.disabled} title={props.title}>
            <Icon icon={props.icon}/>
        </button>
    );
}